import { useCallback, useEffect, useRef, useState } from "react";

export function useQuinnPanelResize(setWidth: (width: number) => void) {
    const [isResizing, setIsResizing] = useState(false);
    const cleanupRef = useRef<(() => void) | null>(null);

    useEffect(() => {
        return () => cleanupRef.current?.();
    }, []);

    const startResize = useCallback(
        (event: React.PointerEvent<HTMLDivElement>) => {
            event.preventDefault();
            cleanupRef.current?.();
            setIsResizing(true);

            function onMove(moveEvent: PointerEvent) {
                setWidth(window.innerWidth - moveEvent.clientX);
            }

            function cleanup() {
                setIsResizing(false);
                window.removeEventListener("pointermove", onMove);
                window.removeEventListener("pointerup", cleanup);
                window.removeEventListener("pointercancel", cleanup);
                document.body.style.userSelect = "";
                document.body.style.cursor = "";
                cleanupRef.current = null;
            }

            cleanupRef.current = cleanup;
            document.body.style.userSelect = "none";
            document.body.style.cursor = "col-resize";
            window.addEventListener("pointermove", onMove);
            window.addEventListener("pointerup", cleanup);
            window.addEventListener("pointercancel", cleanup);
        },
        [setWidth],
    );

    return { isResizing, startResize };
}
